import { useState, useEffect, useMemo } from "react";
import { FormSalesforceResponse } from "@api/types/form";
import { getFormSalesForce } from "@api";
import { alertService } from "@services";

export function useSalesforceFormSelect(
  region: string,
  selectedUserType: string
) {
  const [fetching, setFetching] = useState<boolean>(false);
  const [salesforceData, setSalesforceData] = useState<
    FormSalesforceResponse
  >();

  useEffect(() => {
    setFetching(true);
    getFormSalesForce(region)
      .then((res) => {
        setFetching(false);
        setSalesforceData(res);
      })
      .catch((error) => {
        setFetching(false);
        alertService.danger({ msg: error.response.data.message });
      });
  }, [region]);

  const userTypeOptions = useMemo(() => {
    return salesforceData
      ? salesforceData.userTypes.map((userType) => userType.accessType)
      : [];
  }, [salesforceData]);

  const userProfileOptions = useMemo(() => {
    if (salesforceData && selectedUserType) {
      const userType = salesforceData.userTypes.find(
        (userType) => userType.accessType === selectedUserType
      );

      return userType ? userType.profiles : [];
    }

    return [];
  }, [salesforceData, selectedUserType]);

  const roleOptions = useMemo(() => {
    return salesforceData ? salesforceData.roles : [];
  }, [salesforceData]);

  return {
    fetching,
    userTypeOptions,
    userProfileOptions,
    roleOptions,
  };
}
